import { c as _c } from "react/compiler-runtime";
import { Dialog } from '@mui/material';
import type { PropsWithChildren } from 'react';
import { SlideUpTransition } from '../animations/transitions';
export const BottomDialog = t0 => {
  const $ = _c(6);
  const {
    open,
    onClose,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      transition: SlideUpTransition
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      "& .MuiDialog-paper": {
        width: "100%",
        maxWidth: "100%",
        height: "85%",
        margin: 0,
        alignSelf: "end",
        marginLeft: "0"
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== onClose || $[4] !== open) {
    t3 = <Dialog slots={t1} open={open} onClose={onClose} sx={t2}>{children}</Dialog>;
    $[2] = children;
    $[3] = onClose;
    $[4] = open;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};